/**
 * Created by karthikeyan.k on 30-11-2018.
 */
export class GameLiveDealer {
  tableId: string;
  betlimitId: string;
  gameTypeId: string;
  gdt: number;
  sessiontoken: string;
  scheme: string;
  serverName: string;
  gameName: string;
  rewriteURL: string;
  serverURL: string;
  lang: string;
  flylogin: boolean;
  initialusertype: string;
  reloadURL: string;
  rchistoryurl: any;
  rciframeurl: any;
  rcinterval: any;
  rcelapsed: any;
  rcenable: any;
  homeurl?: string;
  fullscreen: string;
}
